import React from 'react';
import './LibraryAnswerKeySwitch.css';

/**
 * 라이브러리 학습지 상세 — [학생용 | 정답지].
 * 개요에 정답이 없으면 칩 대신 한 줄만 보여 준다. PPT에는 쓰지 않는다.
 */
export default function LibraryAnswerKeySwitch({ hasAnswers, value, onChange }) {
  if (!hasAnswers) {
    return (
      <p className="library-answer-key-empty" data-testid="library-answer-key-empty">
        이 학습지엔 정답 정보가 없어요
      </p>
    );
  }
  return (
    <div className="library-answer-key-block">
      <div
        aria-label="학습지 보기"
        className="library-answer-key-switch"
        data-testid="library-answer-key-switch"
        role="tablist"
      >
        <button
          aria-selected={value === 'student'}
          className={`library-answer-key-switch__tab${value === 'student' ? ' is-active' : ''}`}
          data-testid="library-page-kind-student"
          onClick={() => onChange('student')}
          role="tab"
          type="button"
        >
          학생용
        </button>
        <button
          aria-selected={value === 'answer'}
          className={`library-answer-key-switch__tab${value === 'answer' ? ' is-active' : ''}`}
          data-testid="library-page-kind-answer"
          onClick={() => onChange('answer')}
          role="tab"
          type="button"
        >
          정답지
        </button>
      </div>
      {value === 'answer' && (
        <p className="library-answer-key-hint" data-testid="library-answer-key-hint">
          한글/PDF로 받으면 학생용 뒤에 이어져요
        </p>
      )}
    </div>
  );
}
